export const debounce = (fn, delay) => {
  let timeoutId = null;

  return function() {
    clearTimeout(timeoutId);
    const args = arguments;
    const self = this;
    timeoutId = setTimeout(() => {
      fn.apply(self, args);
    }, delay);
  };
};

export const whenElementIsVisible = (element, callback, relativeTo = window) => {
  let el = element;

  if (typeof element === 'string') {
    el = document.querySelector(element);
  }

  if (!el) {
    return;
  }

  const destroyEventListener = () => {
    relativeTo.removeEventListener('scroll', scrollPerformed);
  };

  const scrollPerformed = () => {
    const elReference = el.getClientRects()[0];
    if (!elReference) {
      destroyEventListener();
      return;
    }

    let minScrollTop;

    if (relativeTo !== window) {
      const relativeToReference = relativeTo.getClientRects()[0];
      minScrollTop = relativeToReference.top + relativeToReference.height;
    } else {
      minScrollTop = document.scrollingElement.clientHeight;
    }

    if (elReference.top > minScrollTop) {
      return;
    }

    destroyEventListener();
    callback();
  };

  relativeTo.addEventListener('scroll', scrollPerformed);

  return destroyEventListener;
};
